// src/pages/locations/components/form/controlClass.ts

/**
 * Shared control styling so inputs, selects and the country picker line up
 * exactly and share one error appearance.
 */
export function controlClass(error?: string | null, extra = ""): string {
  const base =
    "h-10 w-full rounded-lg border bg-white px-3 text-sm text-gray-900 outline-none transition-colors placeholder:text-gray-400 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500";

  const state = error
    ? "border-red-300 focus:border-red-500 focus:ring-2 focus:ring-red-500/20"
    : "border-gray-300 focus:border-sky-500 focus:ring-2 focus:ring-sky-500/20";

  return `${base} ${state} ${extra}`.trim();
}
